<div>

    <kal-radio-group [formControl]="formControl" class="subvention-type">
        <div>
            <kal-radio [disabled]="!isFixed" [value]="true">
                <span>Subvention fixe : </span>
                <span></span>
            </kal-radio>

            <kal-radio [disabled]="isFixed" [value]="false">
                <span>Subvention variable selon critère : </span>
                <span>{{criterionLabel}}</span>
            </kal-radio>
        </div>
        <div *ngIf="isFixed">
            <ng-container *ngTemplateOutlet="defaultValuesTemplate; context: {values: fixedValues}">
            </ng-container>
        </div>

        <div *ngIf="!isFixed">

            <kal-table [columns]="columns" [dataSource]="displayedRulesList">
                <tr *kalBodyRowDef kal-body-row></tr>
                <tr *kalHeaderRowDef kal-header-row></tr>
            </kal-table>

            <p><strong>Valeur par défaut :</strong></p>

            <ng-container *ngTemplateOutlet="defaultValuesTemplate; context: {values: defaultValues}"></ng-container>

        </div>

    </kal-radio-group>

    <div *ngIf="hasChildrenParameters || hasWeightParameter">

        <div class="gup-O-separationLine"></div>

        <div class="subtitle">Paramètres</div>

        <ng-container *ngIf="hasChildrenParameters">

            <section class="param-list">

                <div class="param-list__item">
                    <span>Enfants : </span>
                </div>

                <div class="param-list__item">
                    <div *ngIf="howMuch.RglModeleIdEnfDir">
                        <kal-icon>check</kal-icon>
                        <span>Direct uniquement</span>
                    </div>
                    <div *ngIf="howMuch.RglModeleIdEnfHan">
                        <kal-icon>check</kal-icon>
                        <span>Handicapé</span>
                    </div>
                    <div *ngIf="howMuch.RglModeleIdEnfAch">
                        <kal-icon>check</kal-icon>
                        <span>À charge uniquement</span>
                    </div>

                    <div *ngIf="howMuch.RglModeleIdAgeEnfMin && !howMuch.RglModeleIdAgeEnfMax">
                        <kal-icon>check</kal-icon>
                        <span>À partir de {{howMuch.RglModeleIdAgeEnfMin}}
                            an{howMuch.RglModeleIdAgeEnfMin, plural, =1 {} other {s}}</span>
                    </div>
                    <div *ngIf="!howMuch.RglModeleIdAgeEnfMin && howMuch.RglModeleIdAgeEnfMax">
                        <kal-icon>check</kal-icon>
                        <span>Jusqu'à {{howMuch.RglModeleIdAgeEnfMax}}
                            an{howMuch.RglModeleIdAgeEnfMax, plural, =1 {} other {s}}</span>
                    </div>
                    <div *ngIf="howMuch.RglModeleIdAgeEnfMin && howMuch.RglModeleIdAgeEnfMax">
                        <kal-icon>check</kal-icon>
                        <span>De {{howMuch.RglModeleIdAgeEnfMin}} à {{howMuch.RglModeleIdAgeEnfMax}}
                            an{howMuch.RglModeleIdAgeEnfMax, plural, =1 {} other {s}}</span>
                    </div>

                </div>

            </section>

            <section class="param-list" *ngIf="howMuch.RglModeleIdAgeEnfMin || howMuch.RglModeleIdAgeEnfMax">
                <div class="param-list__item">
                    <span>Date de référence :</span>
                </div>

                <div class="param-list__item">
                    <span>Age calculé à partir de : </span>
                    <span>{{referenceDate?.Libelle || ''}} {{childrenSelectedDate}}</span>
                </div>

            </section>
        </ng-container>

        <div *ngIf="hasWeightParameter" class="param-list">

            <div class="param-list__item">
                <span>Pondérer selon :</span>
            </div>

            <div class="param-list__item">

                <div *ngIf="howMuch.IsPondererTempsTravail">
                    <kal-icon>check</kal-icon>
                    <span>Pourcentage du temps de travail</span>
                </div>

                <div *ngIf="howMuch.IsPondererMoisPresence">
                    <kal-icon>check</kal-icon>
                    <span>Mois de présence</span>
                </div>

                <div *ngIf="howMuch.IsPondererMoisPresence && howMuch.IsPondererMoisEntier">
                    <kal-icon>check</kal-icon>
                    <span>Mois entier</span>
                </div>

            </div>

        </div>

    </div>

</div>

<ng-template #defaultValuesTemplate let-values=values>

    <section class="enum">

        <div *ngIf="!!values?.Od" class="line">
            <span>Ouvrant droit : </span><span>{{ getDisplayedValue(values.Od) }}</span>
        </div>

        <div *ngIf="!!values?.Conjoint" class="line">
            <span>Conjoint : </span><span>{{ getDisplayedValue(values.Conjoint) }}</span>
        </div>

        <div *ngIf="!!values?.Enfant" class="line">
            <span>Enfant : </span>
            <span>{{ getDisplayedValue(values.Enfant) }} par enfant</span>
        </div>

        <div *ngIf="!!values?.Externe" class="line">
            <span>Externe : </span>
            <span>{{ getDisplayedValue(values.Externe) }} par externe</span>
        </div>

        <div *ngIf="!!values?.ValMin" class="line">
            <span>Valeur minimale : </span>
            <span>{{ getDisplayedValue(values.ValMin) }}</span>
        </div>

        <div *ngIf="!!values?.ValMax" class="line">
            <span>Valeur maximale : </span>
            <span>{{ getDisplayedValue(values.ValMax) }}</span>
        </div>

    </section>

</ng-template>
